<section>
  <figure class="logo">
    <img src="assets/img/intro/logo-with-text.png" alt="DABubble-Logo" (click)="goToAuth()" />
  </figure>
  <div class="main-container">
    <div class="inner-container">
      <div class="inner-container-content">
        <button class="arrow-container" (click)="goBack()">
          <img src="assets\icons\arrow_back.svg" alt="back" />
        </button>
        <div class="text-container">
          <h2>Datenschutzerklärung</h2>
          <p>Letzte Aktualisierung: [JJJJ-MM-TT]</p>
          <p>
            DABubble („wir“, „uns“, „unser“) ist ein Studentenprojekt, das von einem Team aus vier
            Teilnehmern der DAkademie entwickelt wurde. Diese Datenschutzerklärung erläutert, welche
            personenbezogenen Daten wir erfassen, wie wir sie verwenden, mit wem wir sie teilen und
            welche Rechte Sie haben. Wenn Sie sich über „Mit Google anmelden“ einloggen, greifen wir
            auf die Google-Kontoinformationen zu, deren Freigabe Sie uns gestatten (unten
            aufgeführt).
          </p>
          <h3>Verwendung von Google-Anmeldung</h3>
          <p>
            Wenn Sie sich über „Mit Google anmelden“ einloggen, fordern wir Zugriff auf grundlegende
            Profildaten (Name, E-Mail-Adresse, Profilbild, Google-Benutzer-ID) an, um die
            Authentifizierung innerhalb des CRM-Systems zu demonstrieren. Diese Daten werden
            ausschließlich verwendet, um:
          </p>
          <p>Ihre Anmeldesitzung zu authentifizieren.</p>
          <p>Ein Beispiel-Benutzerprofil innerhalb des Demo-CRM zu erstellen.</p>
          <h3>Datenspeicherung</h3>
          <p>
            Die Daten werden vorübergehend in [z. B. Firebase/Lokale Datenbank] gespeichert und
            können jederzeit im Rahmen der Demo gelöscht werden.
          </p>
          <p>Wir speichern oder verwenden Ihre Daten nicht außerhalb des Demonstrationszwecks.</p>
          <h3>Bildungszweck</h3>
          <p>
            Dieses Projekt wurde im Rahmen eines Bootcamp-Programms erstellt, um technische
            Fähigkeiten potenziellen Arbeitgebern zu präsentieren. Es ist nicht für die öffentliche
            Nutzung bestimmt.
          </p>
          <h3>Keine kommerzielle Nutzung / kein Datenverkauf</h3>
          <p>Wir verkaufen, teilen oder kommerzialisieren keine personenbezogenen Daten.</p>
          <h3>Kontakt</h3>
          <p>
            Wenn Sie Fragen zu diesem Projekt haben, können Sie das Team unter folgender Adresse
            erreichen: [dev&#64;davorjezernik.com].
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
